import React from 'react';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/MessagePage.css';

export default function ChairmanMessage() {
  return (
    <Layout bannerTitle="Chairman's Message">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Message from the Chairman" />
          <div className="row g-5 mt-2 align-items-start">
            <div className="col-lg-4 text-center">
              <div className="message-page-photo-wrapper">
                <div className="message-page-photo-placeholder">
                  <i className="fas fa-user-circle"></i>
                </div>
                {/* [PLACEHOLDER: Replace with actual chairman photo] */}
                <h4 className="mp-name">Sanjjev Sir</h4>
                <p className="mp-designation">Chairman</p>
                <p className="mp-school">Akash Model Sr. Sec. School</p>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="message-page-content">
                <p className="message-opening">Dear Friends,</p>
                <p>
                  Welcome to Akash Model Sr. Sec. School. As Chairman of this institution, I am proud
                  to share that our school has been a cornerstone of quality education in Delhi for
                  over 34 years.
                </p>
                <p>
                  Our vision is to create responsible citizens who contribute positively to society.
                  We believe that true education encompasses academic knowledge, moral values, physical
                  fitness, and emotional intelligence. This integrated approach is what sets Akash Model
                  School apart from others.
                </p>
                <p>
                  We have invested heavily in modern infrastructure — AI labs, smart classrooms,
                  state-of-the-art sports facilities, and a well-stocked library — to ensure our
                  students have access to the best resources available.
                </p>
                <p>
                  I am committed to continuously improving the quality of education and overall
                  school experience. Your trust and support motivate us to strive for greater heights
                  every single day.
                </p>
                <p className="message-sign-off">With best wishes,</p>
                <div className="message-signature">
                  <strong>Sanjjev Sir</strong>
                  <span>Chairman, Akash Model Sr. Sec. School</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
